module.exports = __webpack_public_path__ + "img/video_game3.e5ae111b.png";